import { t } from "@/i18n-js/instance";

import type { NotificationToggleKey, SelectableVisibility } from "./types";

export const FORM_ID = "create-space-form";

export const DEFAULT_NOTIFICATION_TOGGLES: NotificationToggleKey[] = [
  "default_notification_setting",
  "default_in_app_notification_setting",
  "default_mobile_notification_setting",
];

export const ALL_NOTIFICATION_TOGGLES: NotificationToggleKey[] = [
  "default_notification_setting",
  "default_in_app_notification_setting",
  "default_mobile_notification_setting",
  "default_mention_mobile_notification_setting",
  "default_mention_in_app_notification_setting",
];

export type VisibilityIconName = "earth" | "lock" | "eye-slash";

export interface VisibilityOptionConfig {
  [key: `data-${string}`]: unknown;
  icon: VisibilityIconName;
  label: string;
  value: SelectableVisibility;
}

export const getVisibilityOptions = (): VisibilityOptionConfig[] => [
  {
    value: "open",
    icon: "earth",
    label: t("spaces.form.create.visibility_types.open"),
  },
  {
    value: "private",
    icon: "lock",
    label: t("spaces.form.create.visibility_types.private"),
  },
  {
    value: "secret",
    icon: "eye-slash",
    label: t("spaces.form.create.visibility_types.secret"),
  },
];

export interface VisibilitySummaryCopy {
  accessLabel: string;
  accessText: string;
  visibilityText: string;
}

export const getVisibilitySummary = (
  value: SelectableVisibility,
): VisibilitySummaryCopy => {
  const map: Record<SelectableVisibility, VisibilitySummaryCopy> = {
    open: {
      accessLabel: t("spaces.form.create.visibility_types.open"),
      accessText: t("spaces.form.create.visibility_types.open_info"),
      visibilityText: t("spaces.form.create.v4.visibility_summary.open"),
    },
    private: {
      accessLabel: t("spaces.form.create.visibility_types.private"),
      accessText: t("spaces.form.create.visibility_types.private_info"),
      visibilityText: t("spaces.form.create.v4.visibility_summary.private"),
    },
    secret: {
      accessLabel: t("spaces.form.create.visibility_types.secret"),
      accessText: t("spaces.form.create.visibility_types.secret_info"),
      visibilityText: t("spaces.form.create.v4.visibility_summary.secret"),
    },
  };
  return map[value];
};
